<template>
  <div class="mb-0-75 border pt-0-5 pb-0-5 dashboard-row-element clickable" @click="goToComment(comment)">
    <div class="row">
      <div class="col-8 col-sm-10 pl-0">
        <strong>
          {{ comment.task.name }}
          <template v-if="comment.task.cardNumber"> - {{ comment.task.cardNumber }}</template>
          <template v-if="comment.createdBy"> - {{ comment.createdBy }}</template>
        </strong>
      </div>
      <div class="col-4 col-sm-2 px-0">
        <span class="text-danger font-nunito--bold" v-if="comment.task.priority == 'high'">High</span>
        <span class="text-warning font-nunito--bold" v-if="comment.task.priority == 'medium'">Medium</span>
        <span class="text-primary font-nunito--bold" v-if="comment.task.priority == 'low'">Low</span>
        <i class='bx bx-task text-muted pull-right theme-color font-20'></i>
      </div>
    </div>
    <div class="row mt-0-5">
      <div class="col" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
        {{ comment.text }}
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "task-summary",
      components: {},
      props: {
        comment: {
          type: [Object, null],
          default() {
            return {
              "id": "0",
              "text": "Some comments for dashboard",
              "createdBy": "Name Surname",
              "createdOn": "2021-10-14 12:18:48",
              "edit": false,
              "editAllowed": false,
              "task": {
                "id": "0",
                "name": "Task to test dashboard",
                "dueDate": null,
                "dueTime": null,
                "notes": "<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\r\ntempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\r\nquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\r\nconsequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\r\ncillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\r\nproident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>",
                "notesText": "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\r\ntempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\r\nquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\r\nconsequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\r\ncillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\r\nproident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
                "type": "to-do",
                "status": "in-progress",
                "priority": "medium",
                "createdAt": "2021-10-14 12:18:08",
                "createdBy": "Name Surname",
                "createdById": "2",
                "assignedTo": "3",
                "cardId": "47",
                "estimateId": "70",
                "cardNumber": "CL00305",
                "estimateNumber": "A00311"
              }
            };
          }
        },
      },
      methods: {
        goToComment(comment) {
          this.$router.push(
            {name: 'CardsEdit', params: {action: 'goToComment', card_id: comment.task.cardId, commentId: comment.id, taskId: comment.task.id}}
          );
        }
      },
    };
</script>

<style scoped>
  .font-20 {
    font-size: 20px;
  }

  .theme-color {
    color: #979595;
  }

  .dashboard-row-element {
    background-color: white;
    padding: 10px 15px !important;
  }

  .wrap-text {
    flex-wrap: wrap;
  }
</style>
